import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=f3a2a3aa&scoped=true&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=f3a2a3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a2a3aa",
  null
  
)

component.options.__file = "CartItem.vue"
export default component.exports